import { render, staticRenderFns } from "./adminInput.vue?vue&type=template&id=07f0f062&scoped=true&"
import script from "./adminInput.vue?vue&type=script&lang=js&"
export * from "./adminInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f0f062",
  null
  
)

export default component.exports